<template>
    <div v-if="current_role == 'employee' && afterMounted == true">
        This section for Students 
    </div>
    <div v-else>
    
    <v-form ref="personal_student" lazy-validation>
        <v-row>
            <v-col>
                <h1>Personal Record</h1>
            </v-col>
        </v-row>
        <div v-if="afterMounted == true">
            <h2 class="page-heading">General Information</h2>
            <v-row>
                <v-col cols="12">
                    <p>Please note changes to your contact info here will not take effect in <a
                            href="https://www.adelphi.edu/safety-transportation/resources/emergency-notification">RAVE
                            Alert</a>.</p>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <span class="label" aria-labelledby="AdelphiId">Adelphi ID</span>
                </v-col>
                <v-col cols="12" sm="9">
                    <span id="AdelphiId" class="black-text">{{ this.personal_data.Idm_ID }}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <span class="label" aria-labelledby="LegalName">Legal Name</span>
                </v-col>
                <v-col cols="12" sm="9">
                    <span id="LegalName" class="black-text">{{ this.personal_data.SProf_Name }}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="3">
                    <span class="label" aria-labelledby="DateOfBirth">Date of Birth</span>
                </v-col>
                <v-col cols="12" sm="9">
                    <span id="DateOfBirth" class="black-text">{{ this.personal_data.SProf_DOB }}</span>
                </v-col>
            </v-row>
            <template v-if="this.intl == true">
                <v-row>
                    <v-col cols="12" sm="3">
                        <span class="label" aria-labelledby="Visa">Visa type</span>
                    </v-col>
                    <v-col cols="12" sm="9">
                        <span id="Visa" class="black-text">{{ this.personal_data.SProf_Visa }}</span>
                    </v-col>
                </v-row>
            </template>
            <v-row class="section-separater" aria-hidden="true"></v-row>

            <h3 class="body-heading">Preferred Name</h3>
            <v-row>
                <v-col cols="12">
                    <p>Please note these fields are case sensitive. Do not use all capitals or all lowercase. Your
                        preferred name will be used on all student records at Adelphi University, except when your legal
                        name is required (such as for transcripts, diplomas, and financial records).</p>
                </v-col>
            </v-row>

            <template>
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-text-field outlined v-model="preferred_first" aria-label="First Name" label="First Name"
                            @input="onChange('preferred_first')" :value="this.personal_data.SProf_PrefFirst"/>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-text-field outlined v-model="preferred_middle" aria-label="Middle Initial" label="Middle Initial"
                            @input="onChange('preferred_middle')" :value="this.personal_data.SProf_PrefMiddle" maxlength="1" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field outlined v-model="preferred_last" aria-label="Last Name" label="Last Name"
                            @input="onChange('preferred_last')" :value="this.personal_data.SProf_PrefLast" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-checkbox v-model="preferred_mailing" label="Use my preferred name on mailings"
                            @change="onChange('preferred_mailing'); onCheckBox();" :value="this.preferred_mailing" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-checkbox v-model="preferred_username" label="Change my username (email will be changed as well)"
                            @change="onChange('preferred_username')" :value="this.preferred_username" />
                    </v-col>
                </v-row>
            </template>

            <h2 class="page-heading">Contact Information</h2>
            <h3 class="body-heading">Phone</h3>
            <v-row>
                    <vue-country-code
                        ref="vccMobile"
                        enabledCountryCode
                        @onSelect="onSelectMobile"
                        :defaultCountry="this.cell_phone_info['iso2']"
                    ></vue-country-code> 

                    <v-text-field v-model="cell_phone_info['phone']" ref="cell_phone_ref" outlined aria-label="Mobile Phone" label="Mobile Phone"
                        @input="onChange('cell_phone')" :value="cell_phone_info['phone']"/>
            </v-row>
            <v-row v-if="!this.intl == true">
                     <vue-country-code
                        ref="vccHome"
                        enabledCountryCode
                        @onSelect="onSelectHome"
                        :defaultCountry="this.home_phone_info['iso2']"
                    ></vue-country-code>

                    <v-text-field v-model="home_phone_info['phone']" ref="home_phone_ref" outlined aria-label="Home Phone" label="Home Phone"
                        @input="onChange('home_phone')" :value="home_phone_info['phone']"/>
            </v-row>

            <template v-if="!this.intl == true">
                <h3 ref="permAddress" class="permAddress">Permanent Address (United States)</h3>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-text-field v-model="address1" outlined aria-label="Street Address" label="Street Address"
                            @input="onChange('address1')" :value="this.personal_data.SProf_Address" required />
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-text-field v-model="address2" outlined aria-label="Address Line 2" label="Address Line 2"
                            @input="onChange('address2')" :value="this.personal_data.SProf_Address_2" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="city" outlined aria-label="City" label="City" @input="onChange('city')"
                            :value="this.personal_data.SProf_City" required :rules="requiredRules" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete v-model="selected_state" aria-label="State" label="State"
                            @input="onChange('selected_state')" outlined clearable :items="states" item-value="PK"
                            item-text="Description" :value="this.personal_data.SProf_State" required :rules="requiredRules" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-mask="'#####-####'" v-model="zip" outlined aria-label="ZIP/Postal Code"
                            @input="onChange('zip')" label="ZIP/Postal Code" :value="this.personal_data.Zip" required :rules="requiredRules" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete v-model="selected_country" aria-label="Country" label="Country"
                            @input="onChange('selected_country')" outlined disabled :items="country"
                            :value="this.personal_data.selected_country" required :rules="requiredRules" />
                    </v-col>
                </v-row>
            </template>

            <h3 ref="localAddress" class="localAddress">Local Address</h3>
            <v-row v-if="!this.intl">
                <v-checkbox v-model="sameAddress" label="My local address is the same as my permanent address above."
                    @change="onChange('sameAddress'); onCheckBox();" :value="this.sameAddress" />
            </v-row>
            <template v-if="!sameAddress">
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-text-field v-model="localAddress1" outlined aria-label="Street Address" label="Street Address"
                            @input="onChange('localAddress1')" :value="this.personal_data.SProf_LAddress" required :rules="requiredRules" />
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-text-field v-model="localAddress2" outlined aria-label="Address Line 2" label="Address Line 2"
                            @input="onChange('localAddress2')" :value="this.personal_data.SProf_LAddress_2" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="localCity" outlined aria-label="City" label="City" @input="onChange('localCity')"
                            :value="this.personal_data.SProf_LCity" required :rules="requiredRules" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete v-model="selected_state_local" aria-label="State" label="State"
                            @input="onChange('selected_state_local')" outlined clearable :items="states" item-value="PK"
                            item-text="Description" :value="this.personal_data.SProf_LState" required :rules="requiredRules" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-mask="'#####-####'" v-model="zip_code_local" outlined aria-label="ZIP/Postal Code"
                            @input="onChange('zip_code_local')" label="ZIP/Postal Code" :value="this.personal_data.LZip" required :rules="requiredRules" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete v-model="selected_country_local" aria-label="Country" label="Country"
                            @input="onChange('selected_country_local')" outlined disabled :items="country"
                            :value="this.personal_data.selected_country_local" />
                    </v-col>
                </v-row>
            </template>
            
            <template v-if="this.intl == true">
                <h3 ref="intlAddress" class="intlAddress">International Address</h3>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-text-field v-model="intlAddress1" outlined aria-label="Street Address" label="Street Address"
                            @input="onChange('intlAddress1')" :value="this.personal_data.SProf_IAddress" required :rules="requiredRules" />
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-text-field v-model="intlAddress2" outlined aria-label="Address Line 2" label="Address Line 2"
                            @input="onChange('intlAddress2')" :value="this.personal_data.SProf_IAddress_2" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="intlCity" outlined aria-label="City" label="City"
                            @input="onChange('intlCity')" :value="this.personal_data.SProf_ICity" required :rules="requiredRules" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="selected_state_intl" aria-label="State" label="State"
                            @input="onChange('selected_state_intl')" outlined :value="this.personal_data.SProf_IRegion" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="zip_code_intl" outlined aria-label="ZIP/Postal Code"
                            @input="onChange('zip_code_intl')" label="ZIP/Postal Code" :value="this.personal_data.IZip" required :rules="requiredRules" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete v-model="selected_country_intl" aria-label="Country" label="Country"
                            @input="onChange('selected_country_intl')" outlined clearable :items="country"
                            :value="this.personal_data.selected_country_intl" required :rules="requiredRules" />
                    </v-col>
                </v-row>
            </template>

            <v-container>
                <h2 class="page-heading">Emergency Contact</h2>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-text-field outlined v-model="emergency_name" aria-label="Emergency Contact Full Name"
                            @input="onChange('emergency_name')" label="Full Name" :value="this.personal_data.SProf_E_ContactName" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-autocomplete v-model="emergency_relationship" aria-label="Relationship" label="Relationship"
                        @input="onChange('emergency_relationship')" outlined clearable :items="['Parent', 'Guardian', 'Other']"
                        item-text="Description" :value="this.personal_data.SProf_E_ContactRelation" />
                    </v-col>
                </v-row>
                <v-row>
                    <vue-country-code
                        ref="vccEmergency"
                        enabledCountryCode
                        @onSelect="onSelectEmergency"
                        :defaultCountry="this.emergency_phone_info['iso2']"
                    ></vue-country-code>
                    <v-text-field v-model="emergency_phone_info['phone']" ref="emergency_phone_ref" outlined aria-label="Emergency Contact Phone" label="Emergency Contact Phone" @input="onChange('emergency_phone')" :value="emergency_phone_info['phone']"/>
                </v-row>
            </v-container>

            <v-container>
                <h2 class="page-heading">Self Identity</h2>
                <p>Pronoun information promotes respectful language when addressing you. Adelphi also welcomes students to
                    share their gender identity and sexual orientation to help foster a supportive environment and enhance
                    services for our LGBTQIA+ community.</p>
                <h3 class="label">Pronouns</h3>
                <v-radio-group v-model="selected_pronoun" @change="onChange('selected_pronoun')">
                    <v-radio v-for="item in preferred_pronouns" :key="item.PK" :label="item.Description" :value="item.PK"/>
                </v-radio-group>

                <h3 class="label">Gender Identity</h3>
                <v-radio-group v-model="selected_gender_identity" @change="onChange('selected_gender_identity')">
                    <v-radio v-for="gi in gi_list" :key="gi.PK" :label="gi.Description" :value="gi.PK"/>
                </v-radio-group>

                <h3 class="label">Sexual Orientation</h3>
                <v-radio-group v-model="selected_sexual_orientation" @change="onChange('selected_sexual_orientation')">
                    <v-radio v-for="or in or_list" :key="or.PK" :label="or.Description" :value="or.PK"/>
                </v-radio-group>
            </v-container>
            <template>
                <v-dialog v-model="addressSuggestion" persistent width="750"  class="pl-4">
                    <v-card>
                        <v-card-title>
                            We were not able to verify your address(s), but found a close match:
                        </v-card-title>
                        <v-card-text v-for="([key, value]) in Object.entries(this.suggestionObj).sort((a, b) => b[0].localeCompare(a[0]))" :key="key">
                            <v-container class="addrDialog">
                            <v-row>
                                <v-col cols="12" md="6" sm="6"  class="pr-0 mr-0 pt-4">
                                    <div class="addrSubtitle">{{ suggestDialog[key] }}Address Entered:</div>
                                    <div class="pl-2">{{ value.street }}</div> 
                                    <div class="pl-2" v-if="value.street2">{{ value.street2 }}</div>
                                    <div class="pl-2">{{ value.city }}, {{ value.state }} {{ value.zipCode }} </div>
                                </v-col>
                                <v-col cols="8" md="6" sm="6" class="ps-0 ml-0 pt-4">
                                    <div class="addrSubtitle">Suggested:</div>
                                    <div class="pl-2">{{ value.sug_line1 }}</div>
                                    <div class="pl-2" v-if="value.sug_line2">{{  value.sug_line2 }}</div>
                                    <div class="pl-2">{{ value.sug_city + ", " +  value.sug_state + " " + value.sug_zip }}</div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="acceptSuggest[key]" row mandatory>                                    
                                        <v-col cols="12" md="6" sm="6">
                                            <v-radio class="dialogRadio" label="Continue as entered" :value=false required ></v-radio>
                                        </v-col>
                                        <v-col cols="8" md="6" sm="6">
                                            <v-radio class="dialogRadio" label="Accept Suggested" :value=true ></v-radio>       
                                        </v-col>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-container>
                        </v-card-text>
                        <v-card-actions>
                                <v-btn class="ml-10" color="primary" @click="() => { addressSuggestion = false; loading = false; }">
                                    Cancel
                                </v-btn>
                                <v-btn class="ml-3" color="primary" @click="() => { addressSuggestion = false; useSuggestion = false; continueSubmission(); }">
                                    Submit Changes
                                </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>

            <template>
                <v-dialog v-model="addressError" persistent width="700">
                    <v-card>
                        <v-card-title>
                            {{ addressErrorTitle }}
                        </v-card-title>
                        <v-card-text>
                            {{ addressErrorText }}
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="#ffb500" @click="addressError = false; loading = false;" class="ml-3" >
                                Okay
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>

            <v-dialog v-model="validate_msg" persistent max-width="450">
                <v-card>
                    <v-card-title>
                        {{ this.validate_msg_title }}
                    </v-card-title>
                    <v-card-text>{{ this.validate_msg_text }}</v-card-text>
                    <v-card-actions>
                        <v-btn @click="closeDialog();" color="#ffb500">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-btn @click="this.saveAllChanges" color="#ffb500" :loading="loading" :disabled="loading"
                class="black--text v-btn v-btn--contained theme--light v-size--x-large">Submit Changes</v-btn>
            <v-dialog v-model="data_saved" persistent max-width="450">
                <v-card>
                    <v-card-title style="white-space: pre-line;">
                        <!-- Your information has been saved. -->
                        {{ this.dialog_text }}
                    </v-card-title>
                    <v-card-actions>
                        <v-btn @click="data_saved = false; reloadPage();" color="#ffb500">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-form>
    </div>
</template>
<script>

import { mask } from "vue-the-mask";
import ClickOutside from "vue-click-outside"
import axios from 'axios'

export default {
    directives: {
        mask,
        ClickOutside
    },
    data: function () {
        return {
            sameAddress: false,
            requiredRules: [(v) => !!v || "Required field cannot be blank."],
            validate_msg: false,
            validate_msg_title: "",
            validate_msg_text: "",
            changed: {},
            formData: new FormData(),
            afterMounted: false,
            loading: false,
            data_saved: false,
            dialog_text: "Your information has been saved.",
            personal_data: null,
            mask: '###-###-####',

            show_tooltip_legal_name: false,
            show_tooltip_preferred_name: false,
            show_tooltip_hispanic: false,
            show_tooltip_white: false,
            show_tooltip_pacific: false,
            show_tooltip_asian: false,
            show_tooltip_black: false,
            show_tooltip_indigenous: false,
            show_tooltip_vietnam: false,
            show_preferred_name: false,

            prefixes: [
                'Mr.',
                'Mrs.',
                'Ms.',
                'Mx.',
                'Dr.',
                'Fr.',
                'Hon',
                'Rabbi',
                'Rev'
            ],
            suffixes: [
                'Esq.',
                'Jr.',
                'Sr.',
                'II',
                'III',
                'IV',
                'V',
                'VI'
            ],

            preferred_prefix: null,
            preferred_first: null,
            preferred_middle: null,
            preferred_last: null,
            preferred_suffix: null,
            preferred_mailing: false,
            preferred_username: false,

            preferred_pronouns: [],
            gi_list: [],
            or_list: [],
            /*
            gender_indentities: {
                1: 'Cisgender Female (non-trans).',
                2: 'Cisgender Male (non-trans)',
                3: 'Gender Non-Conforming (non-binary)',
                4: 'Transgender Female',
                5: 'Transgender Male',
                6: 'Prefer not to share my gender identity'
            },
            orientation_list: {
                1: 'Asexual',
                2: 'Bisexual',
                3: 'Heterosexual',
                4: 'Pansexual',
                5: 'Questioning',
                6: 'Prefer not to share my sexual orientation'
            },
            sexual_orientation: [],
            */
            address1: null,
            address2: null,
            localAddress1: null,
            localAddress2: null,
            intlAddress1: null,
            intlAddress2: null,
            city: null,
            localCity: null,
            intlCity: null,
            zip: null,
            zip_code_local: null,
            zip_code_intl: null,
            intl: false,

            eth_w: false,
            eth_b: false,
            eth_a: false,
            eth_i: false,
            eth: [],
            disabled: false,
            disabled_vet: false,
            vietnam_vet: false,

            current_role: "",

            selected_state: null,
            selected_state_local: null,
            selected_state_intl: null,
            selected_country: "US",
            selected_country_local: "US",
            selected_country_intl: null,
            selected_pronoun: null,
            selected_gender_identity: null,
            selected_sexual_orientation: null,
            //state: [ 'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'NY', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
            states: null,
            country: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombi', 'Comoros', 'Congo (Brazzaville)', 'Congo', 'Costa Rica', 'Cote d&apos;Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor (Timor Timur)', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia, The', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia and Montenegro', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'US', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'],
            //{key: 'NO', value: 'Choose Not to Specify'}, 
            tooltips: {
                legal_name: 'This is the legal name listed on your official W2 forms and may also be needed to ensure the accuracy of claims with benefits. If you change your legal name, please contact Human Resources.',
                pronoun: 'Your pronouns will be displayed on the public directory to help us address you properly.',
                preferred_name: 'The name that you commonly use which is different from your legal name.',
                vietnam: 'Having served between August 1964 and May 7, 1975.',
                hispanic: 'A person of Cuban, Mexican, Puerto Rican, South or Central American, or any other Spanish culture or origin regardless of race.',
                asian: 'A person having origins in the Far East, Southeast Asia, or the Indian subcontinent: including but not limited to Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand and Vietnam.',
                black: 'A person having origins in any of the black racial groups of Africa.',
                pacific: 'A person having origins in Hawaii, Guam or other Pacific Islands.',
                indigenous: 'A person having origins in the original peoples of North and South America (including Central America and Alaska), and who maintain tribal affiliation or community attachment.',
                white: 'A person having origins in Europe, the Middle East or North Africa.'
            },
            addressSuggestion: false,
            addressError: false,
            addressErrorTitle: "Alert!",
            addressErrorText: "We were unable to confirm your address as entered, please try again.",
            suggestionObj: {},
            useSuggestion: false,
            formDataHolder: null,

            suggestDialog : {
                "perm" : "Permanent ", 
                "local" : "Local " ,
                "intl" : "International ", 
            },

            acceptSuggest: {
                "perm" : false,
                "local" : false,
                "intl" : false,
            },

            intlNumbers : {
                "cell_phone": "1",
                "emergency_phone": "1",
                "home_phone": "1"
            },

            cell_phone_info: [], 
            home_phone_info: [],
            emergency_phone_info: [],

        }
    },
    mounted() {
        axios.get('./remote-apis/user-api.php?cmd=cur_role')
            .then((response) => {
              this.current_role = response.data.cur_role;
              if (this.current_role == "employee") {
                window.location = "./remote-apis/auth-redirect.php?goto=personal";
                return;
              }
        })
            .catch((err) => {
              window.console.log(err)
        })

        axios.get('./remote-apis/user-api.php?cmd=personal-student')
            .then(response => {
                this.personal_data = response.data.ROOT.Idm;
                this.intl = (this.personal_data.SProf_Intl_Student === "1" ? true : false);
                this.home_phone_info = this.formatPhoneVar(this.personal_data.SProf_Primary_Phone, this.personal_data.Homephone_ISO);
                this.home_phone = this.home_phone_info['phone'] ;
                this.cell_phone_info = this.formatPhoneVar(this.personal_data.SProf_Mobile_Phone, this.personal_data.Cellphone_ISO);
                this.cell_phone = this.cell_phone_info['phone'] ;
                // this.address1 = typeof this.personal_data.SProf_Address === 'string' ? this.personal_data.SProf_Address.replace(/%/g, "#") : this.personal_data.SProf_Address;
                // this.address2 = typeof this.personal_data.SProf_Address_2 === 'string' ? this.personal_data.SProf_Address_2.replace(/%/g, "#") : this.personal_data.SProf_Address_2;
                // this.localAddress1 = typeof this.personal_data.SProf_LAddress === 'string' ? this.personal_data.SProf_LAddress.replace(/%/g, "#") : this.personal_data.SProf_LAddress;
                // this.localAddress2 = typeof this.personal_data.SProf_LAddress_2 === 'string' ? this.personal_data.SProf_LAddress_2.replace(/%/g, "#") : this.personal_data.SProf_LAddress_2;
                // this.intlAddress1 = typeof this.personal_data.SProf_IAddress === 'string' ? this.personal_data.SProf_IAddress.replace(/%/g, "#") : this.personal_data.SProf_IAddress;
                // this.intlAddress2 = typeof this.personal_data.SProf_IAddress_2 === 'string' ? this.personal_data.SProf_IAddress_2.replace(/%/g, "#") : this.personal_data.SProf_IAddress_2;
                this.address1 = typeof this.personal_data.SProf_Address === 'string' ? decodeURIComponent(this.personal_data.SProf_Address.replace(/\+/g, ' ')) : '';
                this.address2 = typeof this.personal_data.SProf_Address_2 === 'string' ? decodeURIComponent(this.personal_data.SProf_Address_2.replace(/\+/g, ' ')) : '';
                this.localAddress1 = typeof this.personal_data.SProf_LAddress === 'string' ? decodeURIComponent(this.personal_data.SProf_LAddress.replace(/\+/g, ' ')) : '';
                this.localAddress2 = typeof this.personal_data.SProf_LAddress_2 === 'string' ? decodeURIComponent(this.personal_data.SProf_LAddress_2.replace(/\+/g, ' ')) : '';
                this.intlAddress1 = typeof this.personal_data.SProf_IAddress === 'string' ? decodeURIComponent(this.personal_data.SProf_IAddress.replace(/\+/g, ' ')) : '';
                this.intlAddress2 = typeof this.personal_data.SProf_IAddress_2 === 'string' ? decodeURIComponent(this.personal_data.SProf_IAddress_2.replace(/\+/g, ' ')) : '';
                this.city = typeof this.personal_data.SProf_City === 'string' ? decodeURIComponent(this.personal_data.SProf_City.replace(/\+/g, ' ')) : '';
                this.localCity = typeof this.personal_data.SProf_LCity === 'string' ? decodeURIComponent(this.personal_data.SProf_LCity.replace(/\+/g, ' ')) : '';
                this.intlCity = typeof this.personal_data.SProf_ICity === 'string' ? decodeURIComponent(this.personal_data.SProf_ICity.replace(/\+/g, ' ')) : '';
                this.selected_state = typeof this.personal_data.SProf_State === 'string' ? decodeURIComponent(this.personal_data.SProf_State.replace(/\+/g, ' ')) : '';
                this.selected_state_local = typeof this.personal_data.SProf_LState === 'string' ? decodeURIComponent(this.personal_data.SProf_LState.replace(/\+/g, ' ')) : '';
                this.selected_state_intl = typeof this.personal_data.SProf_IRegion === 'string' ? decodeURIComponent(this.personal_data.SProf_IRegion.replace(/\+/g, ' ')) : '';

                this.selected_pronoun = this.personal_data.SProf_PrefGenPro;
                this.selected_gender_identity = this.personal_data.SProf_PrefGenIdent;
                this.selected_sexual_orientation = this.personal_data.SProf_Orientation;
                this.zip = this.personal_data.SProf_Zip;
                this.zip_code_local = this.personal_data.SProf_LZip;
                this.zip_code_intl = this.personal_data.SProf_IZip;
                this.selected_country_intl = this.personal_data.SProf_ICountry;
                this.emergency_name = this.personal_data.SProf_E_ContactName;
                this.emergency_phone_info = this.formatPhoneVar(this.personal_data.SProf_E_ContactPhone, this.personal_data.Emergencyphone_ISO);
                this.emergency_phone = this.emergency_phone_info['phone'] ;
                this.emergency_relationship = this.personal_data.SProf_E_ContactRelation;
                if (this.emergency_relationship && this.emergency_relationship.length > 0) {
                    // Change format from SAAS all upper case format to only first char uppercase:
                    this.emergency_relationship = this.emergency_relationship.charAt(0) + this.emergency_relationship.slice(1).toLowerCase();
                }
                this.disabled = (this.personal_data.Disability === "1" ? true : false);
                this.disabled_vet = (this.personal_data.Disabled_Vet === "1" ? true : false);
                this.vietnam_vet = (this.personal_data.Vietnam_Vet === "1" ? true : false);
                this.legal_prefix = this.personal_data.Prefix;
                this.legal_suffix = this.personal_data.Suffix;
                this.preferred_prefix = this.personal_data.Preferred_Prefix;
                this.preferred_first = this.personal_data.SProf_PrefFirst;
                this.preferred_middle = this.personal_data.SProf_PrefMiddle;
                this.preferred_last = this.personal_data.SProf_PrefLast;
                this.preferred_suffix = this.personal_data.Preferred_Suffix;
                this.preferred_mailing = (this.personal_data.SProf_PrefNameMail === '1' ? true : false);
                this.show_preferred_name = ((this.preferred_prefix !== null || this.preferred_first !== null || this.preferred_middle != null || this.preferred_last !== null || this.preferred_suffix !== null) ? false : true);
                this.afterMounted = true;
            })
            .catch(error => {
                window.console.error(error);
            });
        axios.get('./remote-apis/user-api.php?cmd=pgp')
            .then(response => {
                this.preferred_pronouns = response.data.ROOT.PREF_GENDER_PRONOUNS;
            })
            .catch(error => {
                window.console.error(error);
            });
        axios.get('./remote-apis/user-api.php?cmd=gi')
            .then(response => {
                this.gi_list = response.data.ROOT.Gender_Idents;
            })
            .catch(error => {
                window.console.error(error);
            });
        axios.get('./remote-apis/user-api.php?cmd=or')
            .then(response => {
                this.or_list = response.data.ROOT.Orientations;
            })
            .catch(error => {
                window.console.error(error);
            });
        axios.get('./remote-apis/user-api.php?cmd=st')
            .then(response => {
                this.states = response.data.ROOT.STATES;
            })
            .catch(error => {
                window.console.error(error);
            });

        this.changed = [];
    },
    computed: {
        sorted_pronouns: function () {
            function compare(a, b) {
                if (a.Description < b.Description) {
                    return -1;
                }
                if (a.Description > b.Description) {
                    return 1;
                }
                return 0;
            }
            return this.preferred_pronouns.slice().sort(compare);
        }, 
    },
    methods: {
        safeToUpperCase(value) {
            return (typeof value === 'string') ? value.toUpperCase() : '';
        },
        verify(client, lookup) {
            try {
                return (client.send(lookup));
            }
            catch (err) {
                window.console.log(err);
            }
        },
        onChange(fieldName) {
            if (this.afterMounted) { 
                this.$set(this.changed, fieldName, true);

                if (["cell_phone", "home_phone", "emergency_phone"].includes(fieldName) == true) {
                    let phoneVarName = fieldName + "_info" ;
                    let refName = fieldName + "_ref" ;

                    // numbers only
                    let text = this[phoneVarName]['phone'].replace(/\D/g,'') ;
                    if (!this[phoneVarName]['isIntl']) {
                        // apply US format: xxx-xxx-xxxx
                        if (text.length > 3) text = text.replace(/.{3}/, '$&-'); // Add hyphen at position 4
                        if (text.length > 7) text = text.replace(/.{7}/, '$&-'); // Add hyphen at position 8
                        if (text.length >= 12) {
                            text = text.slice(0, 12);
                        }
                    } else {
                        // intl format, make it less then 20 chars long
                        if (text.length >= 20) {
                            text = text.slice(0, 20) ;
                        }
                    }
                    this[phoneVarName]['phone'] = text ;
                    this.$refs[refName].lazyValue = this[phoneVarName]['phone'] ;
                    return;           
                }

            }
        },
        onCheckBox() {
           // this.preferred_mailing = this.preferred_mailing ? "1" : "0";
        },
        sortPronouns: function (a, b) {
            if (a['Description'] === b['Description']) {
                return 0;
            }
            else {
                return (a[0] < b[0]) ? -1 : 1;
            }
        },
        onSelectMobile({iso2, dialCode}) {
            //this.intlNumbers["cell_phone"] = "+" + dialCode + "-" + iso2;
            let onChange = false;
            if (iso2 != this.cell_phone_info['iso2'])
                onChange = true;
            this.set_phone_country_info("cell_phone", iso2, dialCode);
            if (onChange)
                this.onChange("cell_phone");
        },
        onSelectHome({iso2, dialCode}) {
            let onChange = false;
            if (iso2 != this.home_phone_info['iso2'])
                onChange = true;
            this.set_phone_country_info("home_phone", iso2, dialCode);
            if (onChange)
                this.onChange("home_phone");
        },
        onSelectEmergency({iso2, dialCode}) {
            let onChange = false;
            if (iso2 != this.emergency_phone_info['iso2'])
                onChange = true;
            //this.intlNumbers["emergency_phone"] = "+" + dialCode + "-";
            this.set_phone_country_info("emergency_phone", iso2, dialCode);
            if (onChange)
                this.onChange("emergency_phone");
        },
        set_phone_country_info(name, iso2, dialCode){
            let infoName = name + "_info" ;
            this.intlNumbers[name] = iso2 + "|" + dialCode ;
            this[infoName]['isIntl'] = this.isIntlDialCode(dialCode);   
            this[infoName]['dialCode'] = dialCode;   
            this[infoName]['iso2'] = iso2;   
        },
        isIntlDialCode(dialCode) {
            if (dialCode === "1" || dialCode === 1) 
                return false;   
            else 
                return true;
        },
        closeDialog() {
            this.validate_msg = false;
        },
        saveAllChanges: async function () {
            if (this.$refs.personal_student.validate() == false) {
                this.validate_msg_title = "Required fields cannot be blank." ;
                this.validate_msg_text = "Please review your entries.";
                this.validate_msg = true;
                this.loading = false;                     
                return;  
            }

            this.loading = true;

            let dialCode = "";
            let iso2 = "";
            let tmpCountry = [] ;
            let phoneVarName = "" ;
            let dialCodeVarName = "";
            let isoVarName = "" ;

            this.addrToVerify = 0 ;
            this.verifiedAddr = 0 ;
            this.needSmartyVerify = false;
            var apiPromises = [];

            const SmartySDK = require("smartystreets-javascript-sdk");
            const SmartyCore = SmartySDK.core;
            const Lookup = SmartySDK.usStreet.Lookup;
            let smartyKey = process.env.VUE_APP_SMARTY_KEY;
            const credentials = new SmartyCore.SharedCredentials(smartyKey);
            let clientBuilder = new SmartyCore.ClientBuilder(credentials).withBaseUrl("https://us-street.api.smarty.com/street-address").withLicenses(["us-core-cloud"]);
            let client = clientBuilder.buildUsStreetApiClient();

            for (var key in this.changed) {
                if (["cell_phone", "home_phone", "emergency_phone"].includes(key) == true) {
                    phoneVarName = key + "_info" ;
                    dialCodeVarName = key.replace("_", "") + "_dialcode" ;
                    isoVarName = key.replace("_", "") + "_iso" ; 
                    if (this.intlNumbers[key]) {
                        tmpCountry = this.intlNumbers[key].split("|");
                        dialCode = tmpCountry[1] ;
                        iso2 = tmpCountry[0] ;
                        // phone number: 
                        this.formData.append(key, this[phoneVarName]['phone']);
                        // country code:
                        this.formData.append(isoVarName , iso2 );
                        this.formData.append(dialCodeVarName, dialCode);
                    } else {
                        //intlNumbers should always has a value. Keeping this condition just in case
                        this.formData.append(key, this[phoneVarName]['phone']);
                    }                   
                } else if(typeof key === 'boolean') {
                    this.formData.append(key, this[key] ? "1" : "0");
                } else if (["preferred_mailing"].includes(key) == true) {   
                    if (key == "preferred_mailing") {
                        if (this[key] == "true" || this[key] == true ) {
                            this.formData.append(key, 1);
                        } else { 
                            this.formData.append(key, 0);
                        }
                    }
                } else {
                    this.formData.append(key, this[key]);
                }

                //////////////////////
                if (["localAddress1", "localAddress2", "localCity", "selected_state_local",
                "zip_code_local"].includes(key) == true && !apiPromises.some(lookup => lookup.key == "local")) {
                    let lookUp = new Lookup();
                    lookUp.street = this.localAddress1;
                    lookUp.street2 = this.localAddress2;
                    lookUp.city = this.localCity;
                    lookUp.state = this.selected_state_local;
                    lookUp.zipCode = this.zip_code_local;
                    lookUp.maxCandidates = 3;
                    lookUp.match = "enhanced";

                    apiPromises.push({"key": "local", "promise": this.verify(client, lookUp)});
                }else if (["address1", "address2", "city", "selected_state",
                "zip", "selected_country"].includes(key) == true && !apiPromises.some(lookup => lookup.key == "perm")){
                    let lookUp = new Lookup();
                    lookUp.street = this.address1;
                    lookUp.street2 = this.address2;
                    lookUp.city = this.city;
                    lookUp.state = this.selected_state;
                    lookUp.zipCode = this.zip;
                    lookUp.maxCandidates = 3;
                    lookUp.match = "enhanced";

                    apiPromises.push({"key": "perm", "promise": this.verify(client, lookUp)});
                }
            }

            if (Object.keys(apiPromises).length == 0) {
                this.continueSubmission();
            } else {
                const results = await Promise.allSettled(apiPromises.map(promise => promise.promise));
                var errorString = "";
                results.forEach((result, index) => {
                    const lookup = apiPromises[index];
                    if (result.status === 'fulfilled') {
                        const suggest = result.value.lookups[0];
                        const suggested = suggest.result[0];

                        if (suggested.analysis.dpvMatchCode === "N" || suggested.analysis.enhancedMatch == "none") {
                            this.addressSuggestion = false;

                            switch (lookup.key) {
                                case "local":
                                    errorString = errorString + "local ";
                                    document.querySelector(".localAddress").scrollIntoView();
                                    break;
                                case "perm":
                                    if (errorString.length > 0) {
                                        errorString = errorString + "and permanent ";
                                    }else {
                                        errorString = errorString + "permanent ";
                                    }
                                    document.querySelector(".permAddress").scrollIntoView();
                                    break;
                                case "intl":
                                    if (errorString.length > 0) {
                                        errorString = errorString + "and international ";
                                    }else {
                                        errorString = errorString + "internationl ";
                                    }
                                    document.querySelector(".intlAddress").scrollIntoView();
                                    break;
                            }
                        } else if (this.safeToUpperCase(suggest.street) != this.safeToUpperCase(suggested.deliveryLine1) || this.safeToUpperCase(suggest.street2) != this.safeToUpperCase(suggested.deliveryLine2)  || suggest.zipCode !== suggested.components.zipCode || this.safeToUpperCase(suggest.state)  != this.safeToUpperCase(suggested.components.state) || this.safeToUpperCase(suggest.city) != this.safeToUpperCase(suggested.components.cityName)) {
                            this.suggestionObj[lookup.key] = {
                                street: suggest.street,
                                street2: suggest.street2,
                                city: suggest.city,
                                state: suggest.state,
                                zipCode: suggest.zipCode,
                                sug_line1: suggest.result[0].deliveryLine1,
                                sug_line2: suggest.result[0].deliveryLine2,
                                sug_city: suggest.result[0].components.cityName,
                                sug_state: suggest.result[0].components.state,
                                sug_zip: suggest.result[0].components.zipCode,
                            };

                            if (!(errorString.length > 1)) { //dont throw suggestion if there is already an error
                                this.addressSuggestion = true;
                            }
                        }
                        // this section is meant to fine tune the address matching, right now it throws suggestion if anything in address != smarty suggestion case insensitive
                        // if (suggest.result[0].analysis.dpvMatchCode === "N") {
                        //     this.addressError = true;
                        // // } else if(suggest.result[0].analysis.dpvMatchCode.includes("N")) {
                        // } else if(/A1|CC|F1|G1|M1|M3|N1|P1|RR|U1|UU|V1|ZZ/.test(suggest.result[0].analysis.dpvFootnotes)) { //refine this
                        //     this.suggestionObj[lookup.key] = {
                        //         street: suggest.street,
                        //         street2: suggest.street2,
                        //         city: suggest.city,
                        //         state: suggest.state,
                        //         zipCode: suggest.zipCode,
                        //         sug_line1: suggest.result[0].deliveryLine1,
                        //         sug_line2: suggest.result[0].deliveryLine2,
                        //         sug_city: suggest.result[0].components.cityName,
                        //         sug_state: suggest.result[0].components.state,
                        //         sug_zip: suggest.result[0].components.zipCode,
                        //     };
                        //     this.addressSuggestion = true;
                        // } else {
                        //     this.continueSubmission();
                        // }
                    }
                });

                if(errorString.length > 1){
                    this.addressErrorText = "We were unable to confirm your " + errorString + "address as entered, please try again.";
                    this.addressError = true; //no suggestion available, throw error
                }else if(!this.addressSuggestion){ //if no suggestion or error proceed to submit
                    this.continueSubmission();
                }

            }
        },

        continueSubmission() {
            //TODO: sending data to SAAS....
            if (this.acceptSuggest['local']) {
                this.formData.set("localAddress1", this.suggestionObj['local'].sug_line1);
                this.formData.set("localAddress2", this.suggestionObj['local'].sug_line2);
                this.formData.set("localCity", this.suggestionObj['local'].sug_city);
                this.formData.set("selected_state_local", this.suggestionObj['local'].sug_state);
                this.formData.set("zip_code_local", this.suggestionObj['local'].sug_zip);
            }
            if (this.acceptSuggest['perm']) {
                this.formData.set("address1", this.suggestionObj['perm'].sug_line1);
                this.formData.set("address2", this.suggestionObj['perm'].sug_line2);
                this.formData.set("city", this.suggestionObj['perm'].sug_city);
                this.formData.set("state", this.suggestionObj['perm'].sug_state);
                this.formData.set("zip", this.suggestionObj['perm'].sug_zip);

                if(this.sameAddress) {
                    for (const key in this.changed) {
                        if(key === "zip") {
                            this.formData.set("zip_code_local", this.formData.get('zip'));
                        } else if(key === "city") {
                            this.formData.set("localCity", this.formData.get('city'));
                        } else if(key === "address1") {
                            this.formData.set("localAddress1", this.formData.get('address1'));
                        } else if(key ==="address2") {
                            this.formData.set("localAddress2", this.formData.get('address2'));
                        } else if(key ==="selected_state") {
                            this.formData.set("selected_state_local", this.formData.get('state'));
                        }
                    }
                }
            } else if(this.sameAddress) {
                this.formData.set("localAddress1", this.address1);
                this.formData.set("localAddress2", this.address2);
                this.formData.set("localCity", this.city);
                this.formData.set("selected_state_local", this.selected_state);
                this.formData.set("zip_code_local", this.zip);
            }

            axios.post('./remote-apis/save-student-data.php',
                this.formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then(response => {
                    // sometimes response.data return a string that cannot be parsed into a JSON object
                    if ((typeof response.data === "object" && (response.data.res == "NO_NEW_CHANGES" || response.data.res == "SAAS_RETURN_OK")) || 
                        (typeof response.data === "string" && (response.data.includes("NO_NEW_CHANGES") || response.data.includes("SAAS_RETURN_OK")))) {
                        this.dialog_text = "Your information has been saved.";
                        this.data_saved = true;
                        this.loading = false;
                    } else if ((typeof response.data === "object" && response.data.res == "SAAS_RETURN_FAILURE") ||
                        (typeof response.data === "string" && response.data.includes("SAAS_RETURN_FAILURE")) ) {
                        this.dialog_text = "Your information cannot be saved. \r\nPlease try again later.";
                        this.data_saved = true;
                        this.loading = false;  
                    } else {
                        // not sure what is this...
                        this.dialog_text = "Your information cannot be saved.";
                        this.data_saved = true;
                        this.loading = false;                       
                    }
                })
                .catch(error => {
                    return (alert(error));
                });
        },
        showTooltip(name) {
            eval('this.show_tooltip_' + name + ' = true');
        },
        hide_legal_name() {
            this.show_tooltip_legal_name = false;
        },
        hide_preferred_name() {
            this.show_tooltip_preferred_name = false;
        },
        hide_hispanic() {
            this.show_tooltip_hispanic = false;
        },
        hide_asian() {
            this.show_tooltip_asian = false;
        },
        hide_black() {
            this.show_tooltip_black = false;
        },
        hide_pacific() {
            this.show_tooltip_pacific = false;
        },
        hide_indigenous() {
            this.show_tooltip_indigenous = false;
        },
        hide_white() {
            this.show_tooltip_white = false;
        },
        hide_vietnam() {
            this.show_tooltip_vietnam = false;
        },
        isValidJSON (jsonString){
            try {
                var test = JSON.parse(jsonString);
                if (test && typeof test === "object") {
                    return true;
                }
            }
            catch (e) { 
                window.console.log(e);
                return false; 
            }
        },
        reloadPage() {
            window.location.reload();
        },
        formatPhoneVar(phoneStr, countryStr) {
            let res = {
                iso2 : "US",
                dialCode: "1",
                phone: "",
                isIntl: false,
            } ;
            let tmp_country = [];
            if (phoneStr) {
                tmp_country = decodeURIComponent(countryStr).split("|");
                if (phoneStr.charAt[0] == "+") {
                    // likely data pulled from slate in inconsistance format.
                    // instead of displaying funcky data, display blank
                    res['phone'] = "";
                } else if (tmp_country.length <= 1 ) {
                    // phone number in old pattern
                    res['phone'] = phoneStr;
                } else {
                    // new format: iso2|dialCode
                    res['iso2'] = tmp_country[0];
                    if (tmp_country[1] == "Y")
                        res['dialCode'] = "1";
                    else
                        res['dialCode'] = tmp_country[1];
                    res['phone'] = phoneStr;
                    if (res['dialCode'] != "1" || res['dialCode'] !== 1) {
                        res['isIntl'] = true ;
                    } else {
                        res['phone'] = res['phone'].replace(/.{3}/, '$&-'); 
                        res['phone'] = res['phone'].replace(/.{7}/, '$&-'); 
                    }
                }
            }
            return res;
        },
    },
}
</script>

<style>
.inputs-container {
    .col-12 {
        padding-top: 0;
        padding-bottom: 0;
    }
}
.h2 {
    margin: 0px;
    font-size: 2em;
}
.h3 {
    margin: 0px;
    font-size: 1.4em;
}
.vue-country-select {
    margin-bottom: 30px;
    margin-right: 10px;
}
.section-separater {
    padding: 6px;
    border-bottom: 4px solid #ffb500 !important;
}
.dialogRadio label {
  font-weight: 500 !important;
  font-size: 14px !important;
  width: 40% !important;
}

.suggestHr {
    border-bottom: 1px solid #ffb500 !important;
}

.addrDialog {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
}

.addrSubtitle {
    font-weight: bold !important;
    background-color:#ffd500 !important;
    padding: 4px 4px 4px 8px !important; 
}

.v-card__text {
    padding-bottom: 0px !important;
}

</style>